import { render, staticRenderFns } from "./marketList.vue?vue&type=template&id=0d9933ee&scoped=true&"
import script from "./marketList.vue?vue&type=script&lang=js&"
export * from "./marketList.vue?vue&type=script&lang=js&"
import style0 from "./marketList.vue?vue&type=style&index=0&id=0d9933ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9933ee",
  null
  
)

export default component.exports